import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowHover, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';
import { useParams } from 'react-router-dom';


const newsItems = [
  {
    id: 1,
    imgSrc: subMenuHome,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '15.04.2025',
  },
  {
    id: 2,
    imgSrc: subMenuPartners,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '12.04.2025',
  },
  {
    id: 3,
    imgSrc: subMenuProjects,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '10.04.2025',
  },
  {
      id: 4,
      imgSrc: subMenuHome,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '15.04.2025',
    },
    {
      id: 5,
      imgSrc: subMenuPartners,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '12.04.2025',
    },
    {
      id: 6,
      imgSrc: subMenuProjects,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '10.04.2025',
    },
    {
      id: 7,
      imgSrc: subMenuHome,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '15.04.2025',
    },
    {
      id: 8,
      imgSrc: subMenuPartners,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '12.04.2025',
    },
    {
      id: 9,
      imgSrc: subMenuProjects,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '10.04.2025',
    },
];
 
const NewsDetailItems = () => {


      const { t } = useTranslation();

      const { id } = useParams();

      const [singleNews, setSingleNews] = useState("")

      useEffect(() => {


        const filteredTour = newsItems.find(product => product.id == id);
        setSingleNews(filteredTour);
    
      }, []);

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
       <div className='max-w-containerSm md:max-w-container mx-auto '>
        <div className='flex justify-between'>
          <div className='w-[65%] text-[#1C1C1C]'>
    <p className='text-[26px] font-medium'>{singleNews.title}</p>
    <p className='mt-6'>{singleNews.description}</p>
          </div>
          <div className='w-[30%]'>
          <div className="relative w-full">
             <img src={singleNews.imgSrc} className='w-full' alt='' />
             <span className='absolute top-3 right-3 text-[#008A7F] bg-[#F6FAFA] text-[12px] h-[21px] w-[83px] rounded-[12px] text-center flex items-center justify-center'>
               {singleNews.date}
             </span>
           </div>
          </div>
        </div>
        <div className='flex justify-between items-center mt-[104px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px] mx-auto md:mx-0'>Digər xəbərlər</p>
       <a className='hidden md:block group' href='/news'>
                             <div className='flex justify-between items-center w-[144px] rounded-[12px] bg-[#fbfbfb] text-[#1C1C1C] h-[46px]'>
                                 <p className="transition-colors duration-300 group-hover:text-[#008A7F]">Hamısına bax</p>
                                    <img
                                      className='w-2 transition-opacity duration-300 group-hover:hidden'
                                      src={rightArrow}
                                      alt=""
                                    />
                                    <img
                                      className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                      src={rightArrowHover}
                                      alt=""
                                    />
                              </div>
                             </a>
        </div>
       <div className='grid grid-cols-1 md:grid-cols-4 gap-5 mt-[32px]'>
        {newsItems.slice(0, 4).map((item) => (
         <a key={item.id} href={`/news/${item.id}`}>
         <div className='group overflow-hidden rounded-lg'>
           <div className="relative">
             <img src={item.imgSrc} className='w-full transition-transform duration-300 group-hover:scale-105' alt='' />
             <span className='absolute top-3 right-3 text-[#008A7F] bg-[#F6FAFA] text-[12px] h-[21px] w-[83px] rounded-[12px] text-center flex items-center justify-center'>
               {item.date}
             </span>
           </div>
           <p className='mt-3 text-[#1C1C1C]'>{item.title.slice(0, 80)}..</p>
         </div>
       </a>
            ))}
             <a className='block md:hidden' href='/news'>
                             <div className='flex justify-between mx-auto items-center w-[144px] rounded-[12px] bg-[#fbfbfb] text-[#1C1C1C] h-[46px]'>
                                <p>Hamısına bax</p>
                                <img className='w-2' src={rightArrow}></img>
                              </div>
                             </a>


    </div>
       </div>
    </div>
  )
}

export default NewsDetailItems